/** Scoped print CSS for Client Assessment — tighter margins and compact sections. */
export const ASSESSMENT_PRINT_STYLES = `
  @media print {
    @page {
      size: letter portrait;
      margin: 0.35in 0.45in;
    }

    .assessment-print-sheet {
      padding: 0 !important;
      margin: 0 !important;
      max-width: 100% !important;
    }

    .assessment-print-sheet > header {
      margin-bottom: 0.25rem !important;
      padding-bottom: 0.25rem !important;
    }

    .assessment-print-sheet > header h1 {
      font-size: 14px !important;
      line-height: 1.25 !important;
    }

    .assessment-print-sheet > header p {
      margin-top: 0.125rem !important;
      font-size: 11px !important;
    }

    .assessment-print-section {
      margin-bottom: 0.35rem !important;
      break-inside: avoid;
      page-break-inside: avoid;
    }

    .assessment-print-section > div:first-child {
      padding-top: 0.2rem !important;
      padding-bottom: 0.2rem !important;
    }

    .assessment-dual-columns {
      align-items: start !important;
      gap: 0.35rem !important;
      padding: 0.25rem 0.5rem !important;
    }

    .assessment-dual-panel {
      min-height: 0 !important;
      height: auto !important;
    }

    .assessment-dual-panel > div:last-child {
      flex: none !important;
      padding: 0.25rem 0.35rem !important;
    }

    .assessment-print-sheet .min-h-\\[32px\\] {
      min-height: 0 !important;
    }

    .assessment-print-matrix-row {
      min-height: 0 !important;
      padding-top: 0.1rem !important;
      padding-bottom: 0.1rem !important;
    }
  }
`;
